// import Swiper bundle with all modules installed
import Swiper from 'swiper/bundle';
const {ValidationError} = require('./exception.js');
const selector = require('./selector.js');

/*
    この行のため、webpack.config.jsにpluginの仕込みが必要
*/
const backend_uri=from_webpack.backend_uri;
const upload_url=`${backend_uri}/upload`;
const operation_url=`${backend_uri}/operation`;
const verify_url =`${backend_uri}/verify`;

(function () {

    const { 
        find_entry_item,
        set_feedback_message,
        disable_tab_stop_in_section,
        compose_fetch_option,
        compose_ajax
    } = require('./util.js');

    const {
        prepare_ary_form_page,
        set_skip,reset_skip,
        go_next,
        go_previous,
        on_jump
    } = require('./transition.js');

    
    const check_entry_item = require('./check_entry_item.js');

    let HTML_next_button_inner;
    let DOM_next_button;
    let next_button_text_changed = true;

    const later = (delay, value) => {
        return new Promise((resolve) => {
            setTimeout(resolve, delay, value); // Note the order, `delay` before `value`
        });
    }    

    const fetch_default_options = () => {
        return {
            method: 'POST',
            headers: {
                "Content-Type": "application/x-www-form-urlencoded"
            },
            mode: 'cors',
            credentials: 'include'
        };
    }


    const init_application_swiper = () => {
        
        const swiper = new Swiper('div.Application', {
            // Optional parameters
            slidesPerView:1,
            // If we need pagination
            pagination: {
                el: '.swiper-pagination',
            },
            noSwiping: true,
            noSwipingClass: 'swiper-slide',
            // Navigation arrows
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            // And if we need scrollbar
            scrollbar: {
                el: '.swiper-scrollbar',
            },
            effect:"fade",
        });
        return swiper;
    }

    /*
        entry_nameは枝番なしで記載(ie. entry1,entry2,....)
    */
    const set_section_text = (entry_name,text) => {
        let ary_DOM_slide = document.querySelectorAll(`${selector.application_section} [data-slide-name]`);

        for(var DOM_slide of ary_DOM_slide){
            let slideName=DOM_slide.dataset['slideName'];
            let set_text=false;
            if(slideName == `${entry_name}-1`) set_text=true;
            if(slideName == `${entry_name}-2`) set_text=true;
            if(set_text){
                let selector_section_name=`${selector.application_section} [data-slide-name='${slideName}'] .section_name`;
                let DOM_section_name=document.querySelector(selector_section_name);
                if(DOM_section_name !== null){
                    DOM_section_name.innerText=text;
                }
            }
        }
    }
       

    /**
        ジャンプハンドラの仕様
        
        個々のスライドから前後スライドに遷移した時に呼び出されるハンドラ(無名関数など)をon_jump()でセットする。
        FIXME:前後の遷移両方にハンドラを明示的に指定する必要がある。

        ハンドラの関数シグネチャは下の通り：
        const name_of_handler = (application_swiper) { ... }
        また、ハンドラ内でValidationError例外を送出することで、遷移をキャンセルできる。

    */

    ////////////////////////////////////////////////////////////////////////////////

    const on_jump_sections_to_next = async (event,application_swiper) => {

        let ary_DOM_check_section = document.querySelectorAll(`${selector.application_section} input[name='section[]']`);
        let ary_DOM_radio_voice_type = document.querySelectorAll(`${selector.application_section} input[name='voiceType']`);
        let DOM_main_check_section = ary_DOM_check_section[ary_DOM_check_section.length-1];
        let DOM_main_radio_voice_type = ary_DOM_radio_voice_type[ary_DOM_radio_voice_type.length-1];

        let section_count=0;
        let cancel_jump=false;
        let no_voice_type=true;

        reset_skip();

        // セクション数の確認
        for(var DOM_check_section of ary_DOM_check_section){

            if(DOM_check_section.checked){
                let DOM_label = DOM_check_section.labels[0];
                let section_text=DOM_label.innerText;
                set_section_text(`entry${section_count+1}`,section_text);
                section_count++;
            }
        }
        
        // 元々 section_count数は1~3をとっていたが、現在は1しかない
        set_skip('entry3-1');
        set_skip('entry3-2');
        set_skip('entry2-1');
        set_skip('entry2-2');

        if(section_count == 0) {
            let selector_feekback=`${selector.application_section} [data-for="${DOM_main_check_section.id}"]`;
            let DOM_feedback=document.querySelector(selector_feekback);

            if(DOM_feedback){
                DOM_feedback.innerText="参加部門を選択してください。";
            }
            // 選択肢全てを強調する
            for(var DOM_check_section of ary_DOM_check_section){
                DOM_check_section.classList.add('is-invalid');
            }  
            cancel_jump=true;
        } else {
            // 選択肢の強調解除
            for(var DOM_check_section of ary_DOM_check_section){
                DOM_check_section.classList.remove('is-invalid');
            }
        }

        // 声種の未選択がないかチェック
        for(var DOM_radio_voice_type of ary_DOM_radio_voice_type){
            if(DOM_radio_voice_type.checked) {
                no_voice_type=false;
                break;
            }
        }

        if(no_voice_type){
            let selector_feekback = `${selector.application_section} [data-for="${DOM_main_radio_voice_type.id}"]`;
            let DOM_feedback=document.querySelector(selector_feekback);
            if(DOM_feedback){
                DOM_feedback.innerText="声種を選択してください。";
            }
            // 選択肢全てを強調する
            for(var DOM_radio_voice_type of ary_DOM_radio_voice_type){
                DOM_radio_voice_type.classList.add('is-invalid');
            }
            cancel_jump = true;

        } else {
            // 選択肢の強調解除
            for(var DOM_radio_voice_type of ary_DOM_radio_voice_type){
                DOM_radio_voice_type.classList.remove('is-invalid');
            }

        }

        if(cancel_jump){
            throw new ValidationError('No section selected');
        }
        return;
    }

    //policies
    const on_jump_policies_to_next = async (event,application_swiper) => {
        let current_slide_name;
        let currentIndex = application_swiper.activeIndex;
        current_slide_name = application_swiper.slides[currentIndex].dataset['slideName'];

        let cancel_jump=false;

        let DOM_check_confirm = document.querySelector(`${selector.application_section} input[name='checkConfirm']`);
        if(DOM_check_confirm){
            if(DOM_check_confirm.checked == false){
                set_feedback_message(DOM_check_confirm,"承認のチェックを入れてください。");
                DOM_check_confirm.classList.add('is-invalid');
                cancel_jump = true;
            } else {
                DOM_check_confirm.classList.remove('is-invalid');
            }

        }

        if(cancel_jump){
            throw new ValidationError('invalid entry input');
        }

    }

    const on_jump_entry_to_next = async (event,application_swiper) => {
        let current_slide_name;
        let currentIndex;
        let DOM_current_slide;
        let is_third_entry_slide;
        let is_artsong_slide;

        let cancel_jump=false;
        const is = require('./form_checker.js');
        ////////////////////////////////////////////////////////////////////////////////
        // サブルーチン
        ////////////////////////////////////////////////////////////////////////////////
        

        currentIndex = application_swiper.activeIndex;
        DOM_current_slide = application_swiper.slides[currentIndex];
        current_slide_name = DOM_current_slide.dataset['slideName'];


        // 一枚目、二枚目、三枚目でルーチンを共有にするので、三枚目かどうか確認をする
        // なお、entry系スライドの命名規則上、一枚目はentry1-1、entry2-1 等、`-1`で終わる
        if(current_slide_name.endsWith('-3')){
            is_third_entry_slide=true;
        } else {
            is_third_entry_slide=false;
        }

        let check = check_entry_item.bind(null,current_slide_name,application_swiper,false);

        let ary_form_check_data = [
            [is.not_empty,'composer','作曲者'],
            [is.not_empty,'titleOriginalLanguage','曲目(原語)'],
            [is.not_empty,'titleLocalLanguage','曲目(邦語)']
        ];

        if(is_third_entry_slide){
            const extra_check = [[is.not_empty,is.valid_url],'youtubeURL','提出作品URL'];
            ary_form_check_data.push(extra_check);
        }

        for(var check_param of ary_form_check_data){
            try {
                check.apply(null,check_param);
            } catch(err){
                cancel_jump = true;

            }
        }
        
        if(cancel_jump){
            throw new ValidationError('invalid entry input');
        }
        
    }

    const on_jump_personal1_to_next = async (event,application_swiper) => {
        let current_slide_name;
        let currentIndex;
        let is_first_entry_slide;

        let cancel_jump=false;
        const is = require('./form_checker.js');
        ////////////////////////////////////////////////////////////////////////////////
        // サブルーチン
        ////////////////////////////////////////////////////////////////////////////////
        

        currentIndex = application_swiper.activeIndex;
        current_slide_name = application_swiper.slides[currentIndex].dataset['slideName'];

        let check = check_entry_item.bind(null,current_slide_name,application_swiper,true);

        let ary_form_check_data = [
            [is.not_empty,'name','お名前'],
            [is.not_empty,'nameKana','フリガナ'],
            [is.valid_email,'email','メールアドレス'],
            [is.not_empty,'tel','電話番号'],
            [is.not_empty,'address','住所']            
        ];

        for(var check_param of ary_form_check_data){
            try {
                check.apply(null,check_param);
            } catch(err){
                console.log(err);
                cancel_jump = true;
            }
        }
        
        if(cancel_jump){
            throw new ValidationError('invalid entry input');
        }
        
    }

    const change_next_button_text= (DOM_target,text) => {
        DOM_next_button = DOM_target;
        if('innerHTML' in DOM_next_button){
            HTML_next_button_inner = DOM_next_button.innerHTML;
            DOM_next_button.innerHTML = text;
            next_button_text_changed = true;
        }
    }

    const revert_next_button_text = () => {
        if(next_button_text_changed){
            DOM_next_button.innerHTML = HTML_next_button_inner;
            next_button_text_changed = false;
        }
    }

    const on_jump_personal2_to_next = async (event,application_swiper) => {
        const is = require('./form_checker.js');

        let current_slide_name;
        let currentIndex;

        let cancel_jump;

        let json;
        


        let ary_form_check_data = [
            [is.not_empty,'nameRoman','パスポート上の表記でお名前'],
            [is.not_empty,'birthdate','誕生日'],
        ];


        var routine=Promise.resolve();
        

        currentIndex = application_swiper.activeIndex;
        current_slide_name = application_swiper.slides[currentIndex].dataset['slideName'];

        //event.target
        let check = check_entry_item.bind(null,current_slide_name,application_swiper,true);


        for(var check_param of ary_form_check_data){
            try {
                check.apply(null,check_param);
            } catch(err){
                console.log(err);
                cancel_jump = true;
            }
        }

        change_next_button_text(event.target,`<img class="loading" src="image/misc/loading.png">`)

        if(cancel_jump){
            console.log(err);
            throw new ValidationError('invalid entry input');
        }

        // ローカル関数 entry_item(name):
        // name属性で指定スライド内のフォーム項目を検索する。
        // 検索は完全一致で行われる。
        let entry_item = find_entry_item.bind(null,current_slide_name,true);

        let DOM_passport_picture;
        DOM_passport_picture = entry_item('passportPicture');

        routine = routine.then(
            compose_ajax({
                verify_url:verify_url,
                form_data_verify:()=>{
    
                    // このハンドラは、URLSearchParamsオブジェクトのインスタンスが返っていればよいが、
                    // 通常は不便なので、form要素から生成する
                    const DOM_form=document.querySelector("form");
                    const query_param = new URLSearchParams(new FormData(DOM_form));
    
                    // TODO:
                    // ベリファイ前に何か表示する処理が必要であればここに実装する
                    
                    // html側にname='target'のinput要素がない場合はここでセットする。
                    // なお、二重にセットしてしまうとinvalid_targetになるので注意
                    //query_param.append('target',"application_mail");
                    
                    // 追加で必要なデータがあればここでセットする。
                    // query_param.append('stripeToken',ary_stripe_token_data.id);

                    return query_param;
                },
                operation_url:operation_url,
                form_data_operation:(json,query_param)=>{
                    // 引数のjsonはベリファイ処理の結果が入ったオブジェクトである。
                    // 引数のquery_paramはURLSearchParamsオブジェクトのインスタンスである。
                    // このハンドラの役目は、query_paramにトークンをセットして返すことである。
                    
                    switch(json.cause){
                        // ただし、トークンセットができるのはjson.causeがVerifyPassedの場合のみ
                        case "VerifyPassed":
                            query_param.append('token',json.token);
                            break;
                        // そうでない場合はValidateError例外を生成し、jsonを紐づけてからthrowする
                        default:
                            let error = new ValidationError();
                            error.json = json;
                            throw error;
                    }
                    return query_param;
                },
                closing:(json)=>{
                    // 引数のjsonは処理の結果が入ったオブジェクトである。
                    // 処理によっては処理が実際に行われた時点でエラーが生じることもある。
    
                    // このため、この関数においてもjson.causeの内容がエラー(基本的にTokenValid以外)の場合は
                    // 例外を送出する必要がある
                    //if(json.cause === 'StripeCheckoutError'){
                    //    let error = new exception.StripeCheckoutError();
                    //    error.json = json;
                    //    throw error;
                    //}                
                    
                    // TODO:処理完了メッセージの表示などを行う。
                    //modal_finish.show();
                    //console.log(json);
                    DOM_passport_picture.classList.remove('is-invalid');
                    revert_next_button_text();
                }
            })                
        );
        routine = routine.catch(
            (err)=>{
                let json = err.json;
                //compose_ajaxのハンドラが送出した例外をここで処理する。
                if(err instanceof ValidationError){
                    if('ary_verify_result' in json && json.ary_verify_result.length) {
                        let result_index = json.ary_verify_result.findIndex(entry => (entry.query_name === "passportPictureToken"));
                        if(result_index !== -1) {
                            let message;
                            message = json.ary_verify_result[result_index].message.detail;
                            set_feedback_message(DOM_passport_picture,message);
                        }
                        DOM_passport_picture.classList.add('is-invalid');
                        revert_next_button_text();
                        throw err;
                    }
                } else {
                    throw err;
                }
            }
        );
        return routine;

    }

    const active_next_button = (application_swiper) => {

        var ary_DOM_button = document.querySelectorAll(".Application button[data-jumpto='next']");

        for(var DOM_button of ary_DOM_button){

            if(DOM_button){

                if('performAnimation' in DOM_button.dataset){
                    DOM_button.addEventListener('click',
                        (event) => {
                            event.preventDefault();
                        }
                    );

                    DOM_button.addEventListener('transitionend',(event)=>{
                        if(event.propertyName != 'transform') return false;
                        go_next(event,application_swiper);
                    });
                } else {
                    DOM_button.addEventListener('click',
                        (event) => {
                            event.preventDefault();
                            go_next(event,application_swiper);
                        }
                    );

                }
            }
        }
    }
    const active_previous_button = (application_swiper) => {

        var ary_DOM_button = document.querySelectorAll(".Application button[data-jumpto='previous']");

        for(var DOM_button of ary_DOM_button){

            if(DOM_button){
                if('performAnimation' in DOM_button.dataset){
                    DOM_button.addEventListener('click',
                        (event) => {
                            event.preventDefault();
                        }
                    );

                    DOM_button.addEventListener('transitionend',(event)=>{
                        if(event.propertyName != 'transform') return false;
                        go_previous(event,application_swiper);
                    });
                } else {
                    DOM_button.addEventListener('click',
                        (event) => {
                            event.preventDefault();
                            go_previous(event,application_swiper);
                        }
                    );

                }
            }
        }
    }
    const active_file_upload = (application_swiper) => {
        var DOM_passportPicture = document.querySelector(".Application input[name='passportPicture']");
        var DOM_next_button = document.querySelector(".Application button[data-application-mail]");
        if(DOM_passportPicture){
            //compose_fetch_option
            let fetch_option = compose_fetch_option();
            let token_holder_name=DOM_passportPicture.dataset['tokenHolder'];
            let selector_token_holder=`${selector.application_section} input[name="${token_holder_name}"]`

            delete fetch_option.headers["Content-Type"];

            DOM_passportPicture.addEventListener('change',
                (event) => {
                    event.preventDefault();
                    var routine=Promise.resolve();
                    routine=routine.then(()=>{

                        change_next_button_text(DOM_next_button,`<img class="loading" src="image/misc/loading.png">`);
                        DOM_next_button.disabled = true;
                    });
                    routine=routine.then(compose_ajax({
                        fetch_option:fetch_option,
                        url:upload_url,
                        form_data_acquire:()=>{
                            // 将来の拡張用：ticket_json_urlが任意のクエリ引数を受け付ける場合
                            // ここでオブジェクト`URLSearchParams`を生成、適宜`append()`するよう書き換えれば、
                            // クエリ引数を伴ってチケットデータの取得が可能。
                            
                            let formData = new FormData();

                            // このハンドラは、URLSearchParamsオブジェクトのインスタンスが返す必要がある
                            // 何もクエリ引数が必要ない場合は単に当該オブジェクトをnewして返せばよい
                            formData.append('uploaded_file',DOM_passportPicture.files[0]);
                            formData.append('type',DOM_passportPicture.files[0].type);
                            formData.append('target',"upload_ident_button");
                            formData.delete('passportPicture');
                            
                            return formData;
                        },
                        closing:(json)=>{
                            let DOM_token_holder;

                            revert_next_button_text();
                            DOM_next_button.disabled = false;

                            // jsonデーターに応じた処理をここに実装する。
                            if(json.cause != "VerifyPassed"){
                                DOM_passportPicture.classList.add('is-invalid');
                                set_feedback_message(DOM_passportPicture,"ファイルのアップロードに失敗しました。");

                                return Promise.reject(new Error('fail_send_file'));

                            }
                            
                            DOM_token_holder=document.querySelector(selector_token_holder);
                            if(DOM_token_holder == null) return;
                            DOM_token_holder.value=json['token'];
                            
                            DOM_passportPicture.classList.remove('is-invalid');


                        }
                    }));
                    routine=routine.catch((e)=>{
                        return Promise.reject(e);
                    });
                    return routine;
                }
            );
        }
    }

    window.addEventListener('DOMContentLoaded', function (event) {
        // FIXME:フォームテンプレート化する場合は、改装が必要
        let application_swiper;
        prepare_ary_form_page();
        application_swiper = init_application_swiper();

        
        on_jump('policies',on_jump_policies_to_next,null);
        on_jump('sections',on_jump_sections_to_next,null);
        on_jump('entry1-1',on_jump_entry_to_next,null);
        on_jump('entry1-2',on_jump_entry_to_next,null);
        on_jump('entry1-3',on_jump_entry_to_next,null);
        on_jump('entry2-1',on_jump_entry_to_next,null);
        on_jump('entry2-2',on_jump_entry_to_next,null);
        on_jump('entry3-1',on_jump_entry_to_next,null);
        on_jump('entry3-2',on_jump_entry_to_next,null);
        on_jump('personal-info',on_jump_personal1_to_next,null);
        on_jump('personal-info2',on_jump_personal2_to_next,null);

        active_next_button(application_swiper);
        active_previous_button(application_swiper);
        active_file_upload(application_swiper);
        disable_tab_stop_in_section(application_swiper);
    });
})();

window.hoge = ()=>{
    let ary_data=[
        {
            'name':"checkConfirm",
            'value':true
        },
        //
        // 部門/声種選択
        {
            'name':"voiceType",
            'index':1
        },
        {
            'name':"section[]",
            'index':2
        },
        // 音楽経歴
        {
            'selector':`textarea[name="carrier"]`,
            'value':"キャリア１\nキャリア2\nキャリア3"
        },
        // 提出曲目１曲目
        {
            'name':"entry1[0][composer]",
            'value':"原語作曲者1"
        },
        {
            'name':"entry1[0][workname]",
            'value':"原語作品名1"
        },
        {
            'name':"entry1[0][titleOriginalLanguage]",
            'value':"原語曲目1"
        },
        {
            'name':"entry1[0][titleLocalLanguage]",
            'value':"邦語曲目1"
        },
        // 提出曲目２曲目
        {
            'name':"entry1[1][composer]",
            'value':"原語作曲者2"
        },
        {
            'name':"entry1[1][workname]",
            'value':"原語作品名2"
        },
        {
            'name':"entry1[1][titleOriginalLanguage]",
            'value':"原語曲目2"
        },
        {
            'name':"entry1[1][titleLocalLanguage]",
            'value':"邦語曲目2"
        },
        // 提出曲目３曲目
        {
            'name':"entry1[2][composer]",
            'value':"原語作曲者3"
        },
        {
            'name':"entry1[2][workname]",
            'value':"原語作品名3"
        },
        {
            'name':"entry1[2][titleOriginalLanguage]",
            'value':"原語曲目3"
        },
        {
            'name':"entry1[2][titleLocalLanguage]",
            'value':"邦語曲目3"
        },
        {
            'name':"entry1[0][youtubeURL]",
            'value':"https://w.a.com"
        },
        // 個人情報1
        {
            'name':"name",
            'value':"氏名"
        },
        {
            'name':"nameKana",
            'value':"フリガナ"
        },
        {
            'name':"email",
            'value':"calloc@ae.auone-net.jp"
        },
        {
            'name':"tel",
            'value':"090xxxxxxxxxx"
        },
        {
            'name':"address",
            'value':"大阪府大阪xxxxxxxx"
        },
        // 個人情報2
        {
            'name':"nameRoman",
            'value':"SHIMEI"
        },
        {
            'name':"birthdate",
            'value':"1980/01/01"
        },



    ]
        
    for(let input_data of ary_data){
        let DOM_target;
        let ary_DOM_target;

        if('name' in input_data){
            DOM_target=document.querySelector(`[name="${input_data['name']}"]`);
            ary_DOM_target=document.querySelectorAll(`[name="${input_data['name']}"]`);
        } else if('selector' in input_data) {
            DOM_target=document.querySelector(input_data['selector']);
            ary_DOM_target=document.querySelectorAll(input_data['selector']);

        }
        if(DOM_target){
            //要素がinput
            if(DOM_target.matches('input[type="radio"]')){
                // radioの場合は再度取り直す
 
                if(ary_DOM_target[input_data['index']]){
                    ary_DOM_target[input_data['index']].checked=true;
                }
            }
            if(DOM_target.matches('input[type="checkbox"]')){

                if('index' in input_data){

                    if(ary_DOM_target[input_data['index']]){
                        ary_DOM_target[input_data['index']].checked=true;
                    }
    
                } else {
                    DOM_target.checked=input_data['value'];
                }

            }
            //要素がtextareaの場合
            if(DOM_target.matches('textarea')){
                DOM_target.innerText=input_data['value'];
            }

            if(DOM_target.matches('input')){
                DOM_target.value=input_data['value'];
            }


        }
    }
 
}